<ng-container>
  <p class="!text-sub !mb-1">
    {{ message.body }}
  </p>
</ng-container>
